export class DateConverter {
    constructor(format) {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        this.format = format || 'date-time';
    }
    serialize(property) {
        if (property === null) {
            return null;
        }
        switch (this.format) {
            case 'date':
                return DateConverter.toISODateString(property);
            case 'time': {
                const iso = property.toISOString();
                const time = iso.indexOf('T');
                return iso.slice(time + 1);
            }
            case 'date-time-rfc':
                return DateConverter.toRFC(property);
            case 'date-time':
            default:
                return property.toISOString();
        }
    }
    deserialize(value) {
        if (value === null) {
            return null;
        }
        let input = value;
        if (this.format === 'time') {
            input = `1970-01-01T${value}`;
        }
        const date = new Date(input);
        if (date instanceof Date && !Number.isNaN(date.valueOf()))
            return date;
        // throw; in serialize, toISOString will throw if its a compound type
        // serialize/deserialize will handle the case for compound types with
        // date converters
        throw new Error(`Invalid date format: ${value}`);
    }
    static isDate(val) {
        try {
            new DateConverter('date-time').deserialize(val);
            return true;
        }
        catch (e) {
            return false;
        }
    }
    static toISODate(date) {
        return new Date(DateConverter.toISODateString(date));
    }
    static toISODateString(date) {
        return `${date.getUTCFullYear()}-${this.pad(date.getUTCMonth() + 1)}-${this.pad(date.getUTCDate())}`;
    }
    // Generate RFC 3339 date string which looks like this: 2019-10-12T07:20:50.52Z
    // The main difference is that this format does not have milliseconds at the end: 2020-02-13T00:00:00.000Z
    static toRFC(d) {
        return `${d.getUTCFullYear()}-${this.pad(d.getUTCMonth() + 1)}-${this.pad(d.getUTCDate())}T${this.pad(d.getUTCHours())}:${this.pad(d.getUTCMinutes())}:${this.pad(d.getUTCSeconds())}Z`;
    }
    static pad(number) {
        if (number < 10) {
            return `0${number}`;
        }
        return number.toString();
    }
}
//# sourceMappingURL=date-converter.js.map